
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('sm')) {
        this.initAnim()
      }
    })
  },
  methods: {
    initAnim() {
      // this.$gsap.set(this.$refs.bgImg.$el, {
      //   scaleX: 1.08,
      //   scaleY: 1.08,
      // })
      const TL1 = this.$gsap.timeline({
        scrollTrigger: {
          scrub: 0.5,
          start: '10% bottom',
          end: 'bottom top+=20%',
          // markers: true,
          trigger: this.$refs.container,
        },
      })

      TL1.from(this.$refs.bgImg.$el, {
        y: '-=20',
        duration: 0.5,
        ease: 'Power3.easeInOut',
      })
    },
  },
}
